/**
 * Created by lihanying on 2017/6/26.
 */
import React from 'react'
import { Card } from 'antd'
import Compile from '../../../assert/images/compile.svg'
import Modal from './modal'
import Items from './items'
import './style.css'

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      visible: false,
      record: {},
    }
  }

  showModal = (item) => {
    this.setState({ visible: true, record: item })
  }
  handleOk = (items) => {
    const { record } = this.state
    const data = {
      account: items.account || record.account,
      password: items.password || '',
      official_person: items.official_person || record.official_person,
      province: items.province || record.province,
      city: items.city || record.city,
      area: items.area || record.area,
      club_address: items.club_address || record.club_address,
      contact_number: items.contact_number || record.contact_number,
      official_person_phone:
        items.official_person_phone || record.official_person_phone,
      club_name: items.name || record.club_name,
      longitude: items.longitude,
      latitude: items.latitude,
      code: items.code,
    }
    this.setState({ visible: false, record: {} }, () =>
      this.props.fetchEditClubInfo(data)
    )
  }
  handleCancel = (e) => {
    this.setState({ visible: false, record: {} })
  }

  render() {
    const { clubInfo = {}, bankInfo = {}, unionPayInfo, message } = this.props

    const infoItem = [
      {
        title: '负责人',
        value: clubInfo.official_person,
      },
      {
        title: '账号',
        value: clubInfo.account,
      },
      {
        title: '联系电话',
        value: clubInfo.contact_number,
      },
      {
        title: '负责人电话',
        value: clubInfo.official_person_phone,
      },
      {
        title: '详情地址',
        value:
          clubInfo.province +
          clubInfo.city +
          clubInfo.area +
          clubInfo.club_address,
      },
    ]

    const bankItem = [
      {
        title: '持卡人',
        value: bankInfo.name,
      },
      {
        title: '银行卡号',
        value: bankInfo.bankaccount,
      },
      {
        title: '开户银行',
        value: bankInfo.bank_name,
      },
      {
        title: '电话',
        value: bankInfo.phone,
      },
    ]

    const uniconpayItem = [
      {
        title: '户主姓名',
        value: (unionPayInfo && unionPayInfo.userName) || '',
      },
      {
        title: '钱包id',
        value: (unionPayInfo && unionPayInfo.walletId) || '',
      },
      {
        title: '钱包名',
        value: (unionPayInfo && unionPayInfo.walletName) || '',
      },
      {
        title: '电话',
        value: (unionPayInfo && unionPayInfo.mobileNo) || '',
      },
    ]

    return (
      <div className="info">
        <Card
          title={clubInfo.club_name}
          extra={
            <div>
              <img
                src={Compile}
                className="info-icon-img"
                alt="Compile"
                onClick={() => this.showModal(clubInfo)}
              />
            </div>
          }
          style={{ width: '400px', marginRight: '20px' }}
        >
          {infoItem.map((item, idx) => (
            <Items {...item} key={idx} />
          ))}
        </Card>
        {bankInfo.name && (
          <Card title="银行卡信息" style={{ width: '400px' }}>
            {bankItem.map((item, idx) => (
              <Items {...item} key={idx} />
            ))}
          </Card>
        )}
        {unionPayInfo && (
          <Card
            title="银联钱包信息"
            style={{ width: '400px', marginLeft: '20px' }}
          >
            {uniconpayItem.map((item, idx) => (
              <Items {...item} key={idx} />
            ))}
          </Card>
        )}

        {this.state.visible && (
          <Modal
            {...this.state}
            locationMessage={message}
            handleOk={this.handleOk}
            handleCancel={this.handleCancel}
          />
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubInfo/component/info.js